/* Import BreadCrumb config */
import { descriptionOfSteps } from '@/js/breadcrumbConfig.js';
const bcConfig = descriptionOfSteps;

/* FORM configuration */
const formConfig = {

	/* ==== LOCALES BUTTONS ==== */
	formDisplayLangButtons: true,
	/* Buttons can display langs differently */
	modelLangButton: ['countries', 'langs', 'both', 'locale', 'langsFull'][0],


	/* ==== ACTION TYPE ==== */
	// Type of action (set the last nav button label)
	formIsCouponForm: true, // "Claim my coupon"
	formIsCashbackForm: false, // "Claim my cashback"
	formIsContestForm: false, // "Send my participation"


	/* ==== COUPONS RELATED CONFIGURATIONS ==== */
	// There is a coupon in EVERY participation (action coupon, coupon as gift)
	itsAnActionCoupon: true,
	// If not, maybe there is still the POSSIBILITY to have a coupon (survey, coupon at first participation)
	aCouponCouldBeSent: true,
	// Is there a survey?
	thereIsASurveyInThisAction: false,
	/* In any case, if there are multiples coupons, maybe the user can choose one? */
	userCanChooseBetweenCoupons: false,
	howManyCouponsUserCanChoose: 2,
	/* …or we send ALL of them? */
	sendAllCoupons: true,


	/* ==== SHOW GDPR ==== */
	showGdpr: true,


	/* ==== SHOW PARTICIPATION COUNTER ==== */
	participationCounterIsVisible: false,
	// if false, counter is still visible on the "catalog" page for DEV purpose.


	/* ==== IS IT A P&G ACTION? ==== */
	isPnGAction: false,
	// If true, remove GDPR banner, Matotmo script, Cookiefirst script…
	// If true, allow OneTrust banner


	/* ==== REGISTRATIONS ==== */
	// If form require a registration, can the user register on the form?
	userCanRegisterOnTheForm: true,
	// Exemple of "no": 19210, where users were pre-registered by action-api.


	/* ==== ALERT IF META IDs ARE MISSING ==== */
	/* Some IDs are still hard-coded in the form. They MUST be present for the form to work. */
	/* This bit of code try to alert Studio (console or mail) if one is missing. */
	/* To be update manually with the required meta ids */
	thoseMetaIdsMustBePresent : {
				acceptance: [/*5766, 5767, 5768*/],
				production: [/*1881, 1882, 1883*/]
	},


	/* ==== BREADCRUMB ==== */
	isBreadcrumbDisplayed: true,
	isBreadCrumbTitleVisible: true,
	// In the next list, comment steps that you don't need on the form
	listOfBreadcrumbStepsForThisAction: [
		// bcConfig.registration,
		// bcConfig.store,
		// bcConfig.info,
		bcConfig.form,
		// bcConfig.survey,
		// bcConfig.summary,
		bcConfig.confirmation
	],


	/* ==== FORM NAVIGATION ==== */

	// Page collecting data, what user see before confirmation in a normal journey
	formPages : [
		// 'login',
		// 'landing', 
		// "instructions",
		// 'registration', 
		// 'uniqueCode',
		'form1',
		// "choiceSurvey",
		// 'survey',
		// "choosecouponway",
		// "summary",
	],

	// CONDITIONS to unlock buttons on 'currentPage'
	buttonConditionsOnPage: {
		login: ['login', 'password'],
		landing: [],
		instructions: [],
		registration: [
			'email',
			'firstName', 
			'lastName', 
			'phoneNumber1',
		],
		uniqueCode: [
			'uniqueCode'
		],
		form1: [
			// NOTE : les noms des champs doivent être ceux qu'utilise action-api, à la majuscule près.
			'email',
			'firstName', 
			'lastName', 
			/*
			'birthDate'
			'IBAN', 
			'street1', 
			'houseNumber', 
			'postalCode', 
			'city', 
			'countries',
			'idTitle',
			'idGenre',
			"phoneNumber1",
			*/
		],
		form2 : [
			'selectProduct', 
			'file', 
			'conditions',
			/*
			'VATNumber',
			'optin',
			'conditions',
			'idPOPRetailer',
			'selectProduct',
			'purchaseDate',
			'companyName1',
			'orderedItems',
			'deliveryStreet1',
			'deliveryHouseNumber',
			'deliveryCity',
			'deliveryPostalCode',
			'countries2',
			'idLeadTMD1',
			'idLeadTMD2'
*/
		],
		choiceSurvey: [],
		survey: [
			'idLeadTMD1', 
			'idLeadTMD2', 
			'idLeadTMD3'
		],
		summary: [],
		printcoupon: [
			'conditionsCoupons',
		],
	},

				/* ALL default fieldname that can be checked
					'uniqueCode',
					'idGender',
					'idTitle',
					'firstName',
					'lastName',
					'email',
					'phoneNumber1',
					'birthDate'
					'IBAN', 
					'street1',
					'houseNumber',
					'boxNumber',
					'city',
					'postalCode',
					'countries',
					'VATNumber',

					'file',
					'conditions',
					'optin',

					'freeRetailerName',
					'purchaseDate',
					'selectProduct',
					'serialNumber',
					'orderedItems',
					
					'idLeadTMD1',
					'idLeadTMD2'
					
					'companyName1',
					'deliveryStreet1',
					'deliveryHouseNumber',
					'deliveryCity',
					'deliveryPostalCode',
					'countries2',
					'idPOPRetailer',
			*/

			/* ! "countries" must not be required when the google API put the value in the field, as it is not validated by action api then. */
			/* TODO: find a way to make action api validate that field */

	// Page required outside of user's journey
	functionnalPages: [
		"confirmation",
		'confirmRegistration',
		"printcoupon",
		"confirmationCoupon",
		"beforeStart",
		"actionEnded",
		"maxReached",
		"wrongcode",
		"wrongcode2",
		"participated",
		"maintenance",
		"loading",
		"pageError",
		"catalog",
	],

};

export { formConfig };